<div class="drawer-form-wrapper without-bottom-cta" *ngIf="logDetail">
  <div class="behaviour-card-sec">
    <div class="header-with-cta mb-24">
      <h3 class="title s-18">{{ logDetail.templateName }}</h3>
    </div>
    <div class="card-content-wrapper">
      <div class="content">
        <h4 class="title">Date</h4>
        <p class="desc">
          <svg-icon
            src="/assets/icon/icon-calendar.svg"
            class="icon s-16"></svg-icon>
          {{ logDetail.date | userDate: 'MM/dd/yyyy' }}
        </p>
      </div>
      <div class="content">
        <h4 class="title">Time</h4>
        <p class="desc">
          <svg-icon
            src="/assets/icon/icon-clock.svg"
            class="icon s-16"></svg-icon>
          {{ logDetail.time | date: 'hh:mm a' }}
        </p>
      </div>
      <div class="content">
        <h4 class="title">User</h4>
        <p class="desc">
          <svg-icon
            src="/assets/icon/icon-user-sm.svg"
            class="icon s-16"></svg-icon>
          {{ logDetail.userName }}
        </p>
      </div>
    </div>
  </div>
  <div
    class="status added"
    *ngIf="logDetail.auditType === AuditTypeEnums.CREATE">
    <span>Added</span>
  </div>
  <div
    class="status updated"
    *ngIf="logDetail.auditType === AuditTypeEnums.UPDATE">
    <span>Updated</span>
  </div>
  <div
    class="status deleted"
    *ngIf="logDetail.auditType === AuditTypeEnums.DELETE">
    <span>Deleted</span>
  </div>
  <nz-divider class="sec-divider-sm" />
  <p class="log-details-desc">
    {{ logDetail.title }}
  </p>
</div>
